export default "__VITE_ASSET__CNXVtM42__"